// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".book-management{display:flex;padding-top:8px;flex-direction:column}.book-management .book-management-content{display:flex}.book-management .content-container{width:calc(100% - 225px)}", ""]);
// Exports
module.exports = exports;
